export const routesOzluk = [
  {
    path: "/ozluk",
    name: "ozluk",
    component: () => import("@/views/ozluk/index.vue"),
    meta: {
      public: false,
      title: "ozluk.Özlük",
    },
  },
]
